import { optionalContextFactory } from '../../../hooks/optional-context-factory';
import { ResponsiveModalState } from './responsive-modal.types';

const [context, useResponsiveModalContextMethod] = optionalContextFactory<ResponsiveModalState>(
  {} as ResponsiveModalState
);

export type ResponsiveModalProviderProps = React.PropsWithChildren<ResponsiveModalState>;

export const ResponsiveModalProvider = ({ children, ...props }: ResponsiveModalProviderProps) => {
  return <context.Provider value={props}>{children}</context.Provider>;
};

export const useResponsiveModal = () => {
  const { variant, topOffset } = useResponsiveModalContextMethod() ?? {};

  return {
    modalVariant: variant || 'modal',
    isResponsiveMode: variant === 'fullscreenModal',
    topOffset: topOffset || 0,
  };
};

export { useResponsiveModalContextMethod as useResponsiveModalContext };
